"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressModule = void 0;
const base_1 = require("./base");
class ProgressModule extends base_1.SurveyModule {
    constructor() {
        super(...arguments);
        this._type = "progress";
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            return {
                id: this.id,
                type: this.type,
            };
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        return this.toBuilderConfig();
    }
    editProps() {
        return undefined;
    }
}
exports.ProgressModule = ProgressModule;
//# sourceMappingURL=Progress.js.map